import React, { useMemo } from "react";
import dayjs from "dayjs";
import Modal from "../../Modal/Modal";
import TableAdv from "../../Table/TableAdv/TableAdv";
import SmartTooltip from "../../Info/SmartTooltip";

function buildEmployeeNameById(data) {
  const m = new Map();
  const dates = Array.isArray(data?.dates) ? data.dates : [];
  dates.forEach((row) => {
    const items = Array.isArray(row?.items) ? row.items : [];
    items.forEach((it) => {
      if (it?.employeeId == null) return;
      const id = String(it.employeeId);
      if (m.has(id)) return;
      m.set(id, it?.employeeName ?? id);
    });
  });
  return m;
}

export default function BdmJobsModal({ isOpen, onClose, data, employeeId }) {
  const employeeNameById = useMemo(() => buildEmployeeNameById(data), [data]);
  const employeeName = employeeNameById.get(String(employeeId ?? "")) ?? String(employeeId ?? "");

  const rows = useMemo(() => {
    const jobs = data?.jobs && typeof data.jobs === "object" ? data.jobs : {};
    const out = Object.values(jobs)
      .filter(Boolean)
      .filter((job) => String(job?.bdmId ?? "") === String(employeeId ?? ""))
      .map((job) => ({
        jobId: job?.jobId ?? "",
        jobTitle: job?.jobTitle ?? "",
        companyName: job?.companyName ?? "",
        jobOpenDate: job?.jobOpenDate ? dayjs(job.jobOpenDate).format("YYYY-MM-DD") : "",
      }));

    out.sort((a, b) => {
      const at = dayjs(a.jobOpenDate).valueOf() || 0;
      const bt = dayjs(b.jobOpenDate).valueOf() || 0;
      if (bt !== at) return bt - at;
      return String(a.jobTitle || "").localeCompare(String(b.jobTitle || ""));
    });

    return out;
  }, [data, employeeId]);

  const columns = useMemo(
    () => [
      {
        key: "jobTitle",
        label: "Job Title",
        width: "min-w-[260px]! max-w-[340px]!",
        render: (row) => (
          <SmartTooltip
            description={row?.jobTitle}
            size="xs"
            color="black"
            noicon
            tooltipPosition="bottom"
            portal={true}
          >
            <div className="line-clamp-1">{row?.jobTitle}</div>
          </SmartTooltip>
        ),
      },
      {
        key: "companyName",
        label: "Company",
        width: "min-w-[220px]! max-w-[280px]!",
        render: (row) => (
          <SmartTooltip
            description={row?.companyName}
            size="xs"
            color="black"
            noicon
            tooltipPosition="bottom"
            portal={true}
          >
            <div className="line-clamp-1">{row?.companyName}</div>
          </SmartTooltip>
        ),
      },
      {
        key: "jobOpenDate",
        label: "Job Open Date",
        width: "min-w-[160px]!",
      },
    ],
    [],
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`${employeeName} - Jobs List`}
      width="max-w-5xl"
      bodyClassName="p-0.5 flex-1 overflow-auto"
    >
      <div className="flex-1 overflow-auto flex gap-4 p-0.5">
        <TableAdv
          showSlNo
          columns={columns}
          rows={rows}
          tableId="treeHierarchyBdmJobs"
          toolbarRight={{
            search: true,
            filter: false,
            download: false,
            viewToggle: false,
            fullScreen: false,
            add: [],
          }}
          toolbarLeft={{ add: [] }}
        />
      </div>
    </Modal>
  );
}

